export enum eVariableType {
    Token = 'Token',
    Tokencliente = 'Tokencliente',
    RagioneSociale = 'RagioneSociale',
    IDSocieta = 'IDSocieta',
    IDOperatore = 'IDOperatore',
    SessionData = 'SessionData',
    Keys = 'Keys',
    Logo = 'Logo',
    NomeNumeroBlocco = 'NomeNumeroBlocco',
    NomeNumeroBloccoFornitore = 'NomeNumeroBloccoFornitore',
}

class SessionManager {
    keys?: string[];

    clearSession() {
        this.keys?.forEach((element) => {
            sessionStorage.setItem(element, '');
        });
    }

    set(key: eVariableType, newdata: any) {
        this.keys?.push(newdata);
        sessionStorage.setItem(key, newdata);
        //console.debug("set:" + key, sessionStorage.getItem(key));
    }

    get(key: eVariableType) {
        //console.debug("get key" + key, sessionStorage.getItem(key));
        return sessionStorage.getItem(key);
    }
}
const sessionManager: SessionManager = new SessionManager();

export default sessionManager as SessionManager;
